export const NIGHT_TITLE_MAX_LENGTH = 40;

export const normalizeNightTitle = (value) =>
  String(value || '').trim().slice(0, NIGHT_TITLE_MAX_LENGTH);

export const clipNightTitleInput = (value) =>
  String(value || '').slice(0, NIGHT_TITLE_MAX_LENGTH);

export const isNightTitleTooLong = (value) =>
  String(value || '').trim().length > NIGHT_TITLE_MAX_LENGTH;
